import {
    DesktopOutlined,
    AppstoreAddOutlined,
    PieChartOutlined,
    TeamOutlined,
    UserOutlined,
    ShoppingOutlined,
    DollarCircleOutlined,
    StockOutlined,
    LockOutlined,
    DashboardOutlined,
    FileTextOutlined,
    ArrowDownOutlined,
    ControlOutlined,
    SettingOutlined,
    SwapOutlined
} from '@ant-design/icons';

// Import components
import Users from './components/pages/users/users';
import HomePage from './components/pages/homePage';
import Shops from './components/pages/shops/shops';
import Roles from './components/pages/users/roles';
import { ProductsTabWrapper, CategoriesTabWrapper, SubCategoriesTabWrapper } from './components/pages/product/products_hub';
import ExpiredProducts from './components/pages/product/expired_products';
import InventoryManagement from './components/pages/product/inventory_management';
import CustomerLedger from './components/pages/users/customerledger';
import Customers from './components/pages/users/customers';
import Vendors from './components/pages/users/vendors';
import Accounts from './components/pages/accounts/accounts';
import PurchaseOrder from './components/pages/purchase_order/post_purchase_order';
import PurchaseOrderList from './components/pages/purchase_order/purchase_order_list';
import PurchaseOrderEdit from './components/pages/purchase_order/purchase_order_edit';
import PurchaseOrderView from './components/pages/purchase_order/purchase_order_view';
import { SalesPostWrapper, SalesListWrapper, SalesCloseWrapper, SalesTrackingWrapper, SalesReportsWrapper } from './components/pages/sales/sales_hub';
import SalesView from './components/pages/sales/view_sales';
import EditSales from './components/pages/sales/edit_sales';
import ProductSales from './components/pages/sales/product_sales';
// CloseSales is integrated in SalesHub
import PostAdjustment from './components/pages/adjustment/post_adjustment';
import ProductAdjustments from './components/pages/adjustment/view_adjustments';
import RolePermissionGroupList from './components/pages/permission/role_group_permission';
import Debits from './components/pages/Debits/debits';
// SalesReports is integrated in SalesHub
import SalesReportPrint from './components/pages/Reports/document';
import { getPermission, getUserData } from './components/constants';
import UserPermissionTable from './components/pages/permission/user_operations_permission';
import BusinessPackages from './manage/businessPackages';
import BusinessTypes from './manage/businessType';
import ShopConnections from './components/settings/shop_connections';
import Units from './components/pages/units';
import Currencies from './components/pages/currencies';
import CurrencySettings from './components/pages/currency_setting';
import ProductTransferForm from './components/pages/transfer/transfer_order_form';
import TransferWorkflow from './components/pages/transfer/transfer_workflow';
import TransfersPage from './components/pages/transfer/transfer_page';
import UserChats from './components/pages/chats/userchats';
// OrderTracking is integrated in SalesHub
import ProductBatchMovement from './components/pages/adjustment/batch_management';

const userData = getUserData();
const rolePermission = userData && userData?.user ? userData?.user?.role?.role_permission : {};
const userPermission = getPermission();

const routes = [
     { path: '/', label: 'Dashboard', key: '1', icon: <PieChartOutlined />, component: HomePage },
    // { path: '/', label: 'Dashboard', key: '1', icon: PieChartOutlined, component: HomePage },
    

    // ...(rolePermission?.is_system_owner ? [{
    //     label: 'Control',
    //     key: 'control',
    //     icon: <ControlOutlined />,
    //     children: [
    //         { path: '/manage/packages', label: 'Packages', key: '25', component: BusinessPackages },
    //         { path: '/manage/business-types', label: 'Business Types', key: '26', component: BusinessTypes },
    //         { path: '/manage/currency', label: 'Currencies', key: '30', component: Currencies },             
    //     ],
    // }] : []),
    // Manage Routes
    ...(rolePermission?.is_manage ? [{
        label: 'Manage',
        key: 'manage',
        icon: <UserOutlined />,
        children: [
            { path: '/manage/users', label: 'Users', key: '3', component: Users },
            { path: '/manage/shops', label: 'Shops', key: '4', component: Shops },
           // { path: '/manage/roles', label: 'Roles', key: '5', component: Roles },           
        ],
    }] : []),

     // Permissions
    ...(rolePermission?.is_manage ? [{
        path: '/manage/roles-permission',
        label: 'Permissions',
        key: 'permissions',
        icon: <LockOutlined />,
        component: RolePermissionGroupList
    }] : []),
    ...(rolePermission?.is_manage ? [{
        path: '/manage/employee-permission',
        label: 'Employee Permission',
        key: 'hide',
        component: UserPermissionTable
    }] : []),
    // Items Routes
    ...(rolePermission?.is_stock ? [{
        label: 'Product Management',
        key: 'items',
        icon: <AppstoreAddOutlined />,
        children: [
            { path: '/products', label: 'Products Catalog', key: '9', component: ProductsTabWrapper },
            { path: '/product/category', label: 'Categories', key: 'hide', component: CategoriesTabWrapper },
            { path: '/product/sub-category', label: 'Sub Categories', key: 'hide', component: SubCategoriesTabWrapper },
            { path: '/product/inventory', label: 'Inventory Management', key: '12', component: InventoryManagement },
            { path: '/product/expired', label: 'Expired Products', key: '13', component: ExpiredProducts },
        ],
    }] : []),

    // Purchase Routes
    ...(rolePermission?.is_stock ? [{
        label: 'Purchase',
        key: 'po',
        icon: <ShoppingOutlined />,
        children: [
            { path: '/manage/vendors', label: 'Vendors', key: '7', component: Vendors },
            { path: '/purchase-order', label: 'Purchase Order', key: '14', component: PurchaseOrder },
            { path: '/purchase-orders', label: 'Purchase Order Lists', key: '15', component: PurchaseOrderList },
            { path: '/purchase-orders/edit/:id', label: 'Edit Purchase Order', key: 'hide', component: PurchaseOrderEdit },
            { path: '/purchase-orders/view/:id', label: 'View Purchase Order', key: 'hide', component: PurchaseOrderView },
        ],
    }] : []),

    // Sales Routes
    ...(rolePermission?.is_sales ? [{
        label: 'Sale',
        key: 'sale',
        icon: <DollarCircleOutlined />,
        children: [
            { path: '/post-sales', label: 'POS', key: '16', component: SalesPostWrapper },
            { path: '/manage/customers', label: 'Customers', key: '6', component: Customers },
            { path: '/manage/accounts', label: 'Accounts', key: '8', component: Accounts },
            { path: '/sales-list', label: 'Sales Lists', key: 'hide', component: SalesListWrapper },
            { path: '/order-tracking/:id', label: 'Order tracking', key: 'hide', component: SalesTrackingWrapper },
            { path: '/sales/edit/:id', label: 'Edit Sale', key: 'hide', component: EditSales },
            { path: '/sales/view/:id', label: 'View Sale', key: 'hide', component: SalesView },
            { path: '/sales/view/product', label: 'Product Sales', key: '18', component: ProductSales },
            { path: '/sales/close-reverse', label: 'Close Day sales', key: 'hide', component: SalesCloseWrapper },
            { path: '/manage/customers-ledger', label: 'Customer Ledger', key: 'hide', component: CustomerLedger },
        ],
    }] : []),

    // Stock Adjustment Routes
    ...(rolePermission?.is_stock ? [{
        label: 'Stock Adjustment',
        key: 'stock',
        icon: <StockOutlined />,
        children: [
            { path: '/post-stock-adjustment', label: 'Post Stock Adjustment', key: '20', component: PostAdjustment },
            { path: '/product-stock-adjustment', label: 'Products Stock Adjustments', key: '21', component: ProductAdjustments },
            { path: '/batch-management/:id', label: 'Products Invetory Management', key: 'hide', component: ProductBatchMovement },
        ],
    }] : []),


    // Debits Routes
    ...(rolePermission?.is_sales ? [{
        label: 'Debits',
        key: 'Debits',
        icon: <ArrowDownOutlined />,
        children: [
            { path: '/view-invoice-debits', label: 'Invoice Debits', key: '22', component: Debits },
            
        ],
    }] : []),

      // Reports Routes
    //   ...(rolePermission?.is_sales ? [{
    //     label: 'Reports',
    //     key: 'Reports',
    //     icon: <FileTextOutlined  />,
    //     children: [
    //         { path: '/view-sales-reports', label: 'View sales reports', key: '23', component: SalesReportsWrapper },
    //         { path: '/sales-report-print', label: 'print sales reports', key: 'hide', component: SalesReportPrint },
            
    //     ],
    // }] : []),

    ...(userPermission?.is_transfer ? [{
        label: 'Transfers',
        key: 'Transfers',
        icon: <SwapOutlined  />,
        children: [
            { path: '/transfer', label: 'Transfer Product', key: '31', component: ProductTransferForm },
            { path: '/transfer-workflow/:id', label: 'Transfer Work flow', key: 'hide', component: TransferWorkflow },
            { path: '/transfers-list', label: 'Transfer Lists', key: '32', component: TransfersPage },

        ],
    }] : []),
      
      ...(rolePermission?.is_manage ? [{
        label: 'Settings',
        key: 'settings',
        icon: <SettingOutlined  />,
        children: [
            { path: '/shop-connection', label: 'Connect Shops Or Warehouse', key: '24', component: ShopConnections },
            { path: '/units', label: 'Units', key: '29', component: Units },
            { path: '/currency-setting', label: 'Currency Setting', key: '30', component: CurrencySettings },
        ],
    }] : []),

    
      ...(rolePermission?.is_sales ? [{
        label: 'Chats',
        key: 'chats',
        icon: <TeamOutlined />,
       
        children: [
            { path: '/Chatting', label: 'My Coversations', key: '31', component: UserChats },
       ],
    }] : []),
];

export default routes;